/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-shadow */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  MdClose,
  MdFlight,
  MdInfo,
  MdOutlineEmail,
  MdOutlineShare,
  MdOutlineWhatsapp,
} from 'react-icons/md';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  formatTimeStringAmPmFormat,
  formatTimeString,
  formatDate,
  getConnectingTime,
  convertTravelTime,
  formatCurrency,
  getCabinBaggage,
  failedResponseForFareRules,
  showSupplier,
  getSupplierName,
  getOnlyTerminalNumber,
  getNewDate,
  getNumSeats,
  isMobileWidth,
  isEmpty,
  getFlightNumbers,
  getEquipment,
  getOperatedBy,
  // getValueFromAppConfig,
} from '../../shared/helper-utils/appUtils';
import AppLink from '../../shared/components/app-link/AppLink';
import '../one-way/OneWayResultCard.scss';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import {
  getBrandedFaresApi,
  getClassAvailability,
  getClassAvailabilityFare,
  getFareRulesApi,
  getMiniFareRulesApi,
} from '../../api/flightApi';
import AppModal from '../../shared/components/app-modal/AppModal';
import SelectedFlightDetails from '../one-way/SelectedFlightDetails';
import {
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  DATE_MONTH_VIEW_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  INDIGO_FARERULES_LINK,
} from '../../shared/constants/Constants';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppHidden from '../../shared/components/app-hidden/AppHidden';
import CheckforMobile from '../../shared/components/app-hidden/CheckforMobile';
import StopOverInfo from '../one-way/StopOverInfo';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';
import OneWayFareComponent from '../one-way/OneWayFareComponent';
import FareCard from '../../shared/components/fare-card/FareCard';
import FareBreakup from '../../shared/components/fare-card/FareBreakup';
import { useAppContext } from '../../saas/AppConfigWrapper';
import FareRulesContent from '../../shared/components/fare-rules-content/FareRulesContent';

const FLIGHT_INFO = 'flight';
const FARE_BREAKUP = 'fare-breakup';
const FARE_RULES = 'fare-rules';
const MINIFARES = 'mini-fares';

function RoundTripIntlResultCard({
  onwardFlight,
  returnFlight,
  onFareSelection,
  selectedFare,
  onSelectForEmail,
  showInvoiceFare,
  onwardFares,
  flightsForEmail,
  searchRequest,
  index,
  isAmPmFormat,
  onNavigateToBookingPage,
  onShareViaWhatsapp,
  onShareViaEmail,
  onMoreFaresUpdate = () => {},
}) {
  const { appConfig } = useAppContext();
  const isMobileView = CheckforMobile();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [selectedForEmail, setSelectedForEmail] = useState(false);
  const [isOpenFareRulesDialog, setIsOpenFareRulesDialog] = useState(false);
  const [isOpenMiniFareRulesDialog, setIsOpenMiniFareRulesDialog] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fareRulesHtml, setFareRulesHtml] = useState('');
  const [miniFareRulesHtml, setMiniFareRulesHtml] = useState('');
  const [showFares, setShowFares] = useState(false);
  const [showFlightDetails, setShowFlightDetails] = useState(false);
  const [selectedTab, setSelectedTab] = useState(FLIGHT_INFO);
  const [userSelectedFare, setUserSelectedFare] = useState(
    onwardFlight.flightfare[0],
  );
  const [alert, setAlert] = useState(undefined);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [showClassAvailModal, setShowClassAvailModal] = useState(false);
  const [availClassList, setAvailClassList] = useState([]);
  const [isFareFetched, setIsFareFetched] = useState(false);
  const [repriceResponse, setRepriceResponse] = useState(undefined);
  const [isBranded, setIsBranded] = useState(false);
  const [brandedFareKey, setBrandedFareKey] = useState(undefined);
  const [showBrandedList, setShowBrandedList] = useState(false);
  const [brandedFlightList, setBrandedFlightList] = useState([]);
  const [isMoreFaresLoading, setIsMoreFaresLoading] = useState(false);
  const [isMoreFaresCallDone, setIsMoreFaresCallDone] = useState(false);
  const [showMobileFares, setShowMobileFares] = useState(false);
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [isAmedeusFareRules, setIsAmedeusFareRules] = useState(false);

  const checkForBranded = () => {
    const fares = onwardFlight.flightfare;
    let brandedFare;
    fares.forEach((fare) => {
      const branded = fare.ismorefaresavailable === 'true';
      if (branded) {
        brandedFare = fare;
      }
    });
    if (brandedFare) {
      setBrandedFareKey(brandedFare.nextraflightkey);
      setIsBranded(true);
    }
  };

  useEffect(() => {
    checkForBranded();
  }, []);

  const handleShowBrandedFares = async () => {
    // setShowMoreFares(!showMoreFares);
    if (
      brandedFlightList.length === 0 &&
      onwardFlight?.moreFaresCallDOne !== true
    ) {
      setIsMoreFaresLoading(true);
      const res = await getBrandedFaresApi(
        searchRequest,
        brandedFareKey,
        getUserAgentId(),
        searchRequest.journeytype,
        'international',
      );
      if (
        res &&
        res.flightjourneys[0] !== '' &&
        res.flightjourneys[0] !== undefined
      ) {
        const flightOptions = Array.isArray(res.flightjourneys[0].flightoptions)
          ? res.flightjourneys[0].flightoptions
          : [res.flightjourneys[0].flightoptions];
        flightOptions.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare.totalfq -
            flightOption2.recommendedflight[0].flightfare.totalfq,
        );
        const list = [];
        flightOptions.forEach((fo) => {
          const carrierList = [];
          const returnCarrierList = [];
          const seatsList = [];
          const returnSeatsList = [];
          const unitList = [];
          const returnUnitList = [];
          const weighlist = [];
          const returnWeightList = [];
          const bookingClassList = [];
          const returnBookingClassList = [];
          const airFreeTextList = [];
          const handBagWeightList = [];
          const handBagWeightUnitList = [];
          const returnCabinWeightList = [];
          const returnCabinUnitList = [];
          const equipmentList = [];
          const operatedByList = [];
          const returnEquipmentList = [];
          const returnOperatedByList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            weighlist.push(leg.bagweight);
            unitList.push(leg.bagunit);
            bookingClassList.push(leg.bookingclass);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
            handBagWeightList.push(leg.cabinBagweight);
            handBagWeightUnitList.push(leg.cabinBagunit);
            equipmentList.push(isEmpty(leg.equipment) ? '' : leg.equipment);
            operatedByList.push(isEmpty(leg.operatedby) ? '' : leg.operatedby);
          });
          fo.recommendedflight[1].flightlegs.forEach((leg) => {
            returnCarrierList.push(leg.carrier);
            returnUnitList.push(leg.bagunit);
            returnWeightList.push(leg.bagweight);
            returnCabinWeightList.push(leg.cabinBagweight);
            returnCabinUnitList.push(leg.cabinBagunit);
            returnBookingClassList.push(leg.bookingclass);
            returnSeatsList.push(leg.numseatsavailable);
            returnEquipmentList.push(
              isEmpty(leg.equipment) ? '' : leg.equipment,
            );
            returnOperatedByList.push(
              isEmpty(leg.operatedby) ? '' : leg.operatedby,
            );
          });
          const fare = fo.recommendedflight[0].flightfare;
          fare.supplierName = fo.recommendedflight[0].supplier;
          fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fare.airFreeText = airFreeTextList;
          fare.flightCarrier = carrierList;
          fare.flightCarrierReturn = returnCarrierList;
          fare.numseatsavailable = seatsList;
          fare.returnNumseatsavailable = returnSeatsList;
          fare.flightEquipment = equipmentList;
          fare.flightOperatedBy = operatedByList;
          fare.flightBagWeight = weighlist;
          fare.flightBagUnit = unitList;
          fare.cabinBagweight = handBagWeightList;
          fare.cabinBagunit = handBagWeightUnitList;
          fare.flightBagWeightReturn = returnWeightList;
          fare.flightBagUnitReturn = returnUnitList;
          fare.returnCabinBagweight = returnCabinWeightList;
          fare.returnCabinBagunit = returnCabinUnitList;
          fare.isBrandedFare = true;
          fare.returnBookingClass = returnBookingClassList;
          fare.bookingClass = bookingClassList;
          fare.flightEquipment = equipmentList;
          fare.flightOperatedBy = operatedByList;
          fare.flightEquipmentReturn = returnEquipmentList;
          fare.flightOperatedByReturn = returnOperatedByList;
          list.push(fare);
        });
        const oldFares = [...onwardFlight.flightfare];
        const updatesFares = [...oldFares, ...list];
        updatesFares.sort((fare1, fare2) => fare1.totalfq - fare2.totalfq);
        onwardFlight.flightfare = updatesFares;
        setBrandedFlightList(flightOptions);
        onMoreFaresUpdate(list, onwardFlight.nextraflightkey);
      }
      setIsMoreFaresLoading(false);
    }
    setIsMoreFaresCallDone(true);
    setShowBrandedList(!showBrandedList);
  };

  const handleShowMoreFares = () => {
    if (isBranded && brandedFlightList.length === 0 && !isMoreFaresCallDone) {
      handleShowBrandedFares();
    }
    setShowFares((prev) => !prev);
  };

  const getAvailClasses = async () => {
    setIsLoading(true);
    const res = await getClassAvailability(
      userSelectedFare.nextraflightkey,
      'international',
    );
    if (res) {
      let { flights } = res;
      flights = Array.isArray(flights) ? flights : [flights];
      if (flights.length > 0) {
        flights.forEach((availflight) => {
          let { availclasses } = availflight;
          availclasses = Array.isArray(availclasses)
            ? availclasses
            : [availclasses];
          availflight.availclasses = availclasses;
        });
        const list = flights.map((flt) => ({
          carrier: flt.carrier,
          flightnumber: flt.flightnumber,
          selectedclass: '',
        }));
        setSelectedClasses(list);
        setAvailClassList(flights);
        setShowClassAvailModal(true);
      } else {
        setAlert({
          title: 'Class Availability',
          description: 'Cannot Fetch Details',
          variant: 'error',
        });
      }
    }
    setIsLoading(false);
  };

  const handleCloseClassAvailabilityModal = () => {
    setShowClassAvailModal(false);

    setSelectedClasses([]);
    setAvailClassList([]);
    setRepriceResponse(undefined);
    setIsFareFetched(false);
  };

  const handleClassSelect = (availClass, name, index) => {
    setRepriceResponse(undefined);
    setIsFareFetched(false);
    const list = [...selectedClasses];
    list[index][name] = availClass.class;
    setSelectedClasses(list);
  };

  const handleFetchFare = async () => {
    let selectedClassesCount = 0;
    selectedClasses.forEach((selectedclass) => {
      const isSelectedClass = selectedclass.selectedclass !== '';
      if (isSelectedClass) {
        selectedClassesCount += 1;
      }
    });
    if (selectedClassesCount < selectedClasses.length) {
      setAlert({
        title: 'Fetch Fare',
        description: 'Select on class for every sector',
        variant: 'error',
      });
      return;
    }
    setIsLoading(true);
    const response = await getClassAvailabilityFare(
      userSelectedFare.nextraflightkey,
      'international',
      selectedClasses,
      'roundtrip',
    );
    if (
      response &&
      response.NextraPricingResponseV4 &&
      response.NextraPricingResponseV4.statuscode === '200'
    ) {
      setRepriceResponse(response.NextraPricingResponseV4);
      setIsFareFetched(true);
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'NOK'
    ) {
      setAlert({
        title: 'Booking Error',
        description: response.ApiStatus?.Message,
        variant: 'error',
      });
    } else {
      setAlert({
        title: 'Booking Error',
        description: 'Error',
        variant: 'error',
      });
    }
    setIsLoading(false);
  };

  const handleCloseMobileFare = () => {
    setShowMobileFares(false);
    window.history.back();
  };

  const handleBook = (fare) => {
    onFareSelection(onwardFlight, returnFlight, fare);
    setUserSelectedFare(fare);
    if (isMobileView) {
      handleCloseMobileFare();
    }
  };

  const handleMobileContinue = () => {
    if (isMobileWidth()) {
      window.history.pushState({ popupOpen: true }, '');
      setShowMobileFares(true);
    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      if (showMobileFares) {
        setShowMobileFares(false); // Close the popup instead of navigating
      }
    };

    // Add event listener for popstate
    window.addEventListener('popstate', handlePopState);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showMobileFares]);

  const handleOpenFareRules = async () => {
    // if (['6E', '6ET', '6E7'].indexOf(userSelectedFare.flightCarrier[0]) > -1) {
    //   const link = INDIGO_FARERULES_LINK;
    //   const element = document.createElement('a');
    //   element.href = link;
    //   element.target = '_blank';
    //   element.click();
    //   return;
    // }
    setIsLoading(true);
    const response = await getFareRulesApi(
      userSelectedFare.nextraflightkey,
      '',
      'international',
    );
    if (
      response &&
      response.wsstatus &&
      response.wsstatus.status === 'OK' &&
      response.wsstatus.statusCode === '200'
    ) {
      if (
        JSON.parse(response.farerules_html) &&
        JSON.parse(response.farerules_html)?.html !== '' &&
        JSON.parse(response.farerules_html)?.html !== 'null'
      ) {
        setFareRulesHtml(JSON.parse(response.farerules_html)?.html);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'OK'
    ) {
      if (response.ApiStatus.Result.hasOwnProperty('AllFareRules')) {
        setFareRulesHtml(response.ApiStatus.Result?.AllFareRules.Rule);
      } else if (response.ApiStatus.Result) {
        setFareRulesHtml(response.ApiStatus.Result.Rule);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else {
      setFareRulesHtml(failedResponseForFareRules);
    }
    setIsLoading(false);
    setSelectedTab(FARE_RULES);
  };

  const handleShowMiniFareRules = async (fare) => {
    setIsLoading(true);
    const response = await getMiniFareRulesApi(
      fare.nextraflightkey,
      '',
      'international',
    );
    setIsAmedeusFareRules(false);
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      if (fare.supplierName === 'amadeus') {
        setIsAmedeusFareRules(true);
        let { Rule } = response?.ApiStatus?.Result?.MiniFarerule;
        if (!isEmpty(Rule)) {
          Rule = Array.isArray(Rule) ? Rule : [Rule];
          setMiniFareRulesHtml(Rule);
          setIsOpenMiniFareRulesDialog(true);
        } else {
          setMiniFareRulesHtml([]);
        }
      } else {
        const { Result } = response.ApiStatus;
        if (Result && Result !== '') {
          let { list } = Result;
          list = Array.isArray(list) ? list : [list];
          // const resheduleRules = list.filter(
          //   (rule) => rule?.typequalifier?.toLowerCase() === 'change',
          // );
          // const CancelRule = list.filter(
          //   (rule) => rule?.typequalifier?.toLowerCase() === 'cancellation',
          // );
          const resheduleRules = list.filter((rule) =>
            rule?.typequalifier?.toLowerCase().includes('change'),
          );

          const CancelRule = list.filter((rule) =>
            rule?.typequalifier?.toLowerCase().includes('cancel'),
          );

          const rules = {
            reshedule: resheduleRules || [],
            cancellation: CancelRule || [],
          };
          if (resheduleRules.length > 0 || CancelRule.length > 0) {
            setMiniFareRulesHtml(rules);
            setIsOpenMiniFareRulesDialog(true);
          } else {
            setAlert({
              variant: 'error',
              title: 'Mini Fare Rules',
              description: 'Mini fare rules not available at the moment',
            });
          }
        } else {
          setAlert({
            variant: 'error',
            title: 'Mini Fare Rules',
            description: 'Mini fare rules not available at the moment',
          });
        }
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Mini Fare Rules',
        description: 'Mini fare rules not available at the moment',
      });
    }
    setIsLoading(false);
  };

  const handleFareRulesClick = async (fare) => {
    // if (['6E', '6ET', '6E7'].indexOf(fare.flightCarrier[0]) > -1) {
    //   const link = INDIGO_FARERULES_LINK;
    //   const element = document.createElement('a');
    //   element.href = link;
    //   element.target = '_blank';
    //   element.click();
    //   return;
    // }
    // const fare = flight.flightfare[0];
    setIsLoading(true);
    const response = await getFareRulesApi(
      fare.nextraflightkey,
      '',
      'international',
    );
    if (
      response &&
      response.wsstatus &&
      response.wsstatus.status === 'OK' &&
      response.wsstatus.statusCode === '200'
    ) {
      if (
        JSON.parse(response.farerules_html) &&
        JSON.parse(response.farerules_html)?.html !== '' &&
        JSON.parse(response.farerules_html)?.html !== 'null'
      ) {
        setFareRulesHtml(JSON.parse(response.farerules_html)?.html);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'OK'
    ) {
      if (response.ApiStatus.Result.hasOwnProperty('AllFareRules')) {
        setFareRulesHtml(response.ApiStatus.Result?.AllFareRules.Rule);
      } else if (response.ApiStatus.Result) {
        setFareRulesHtml(response.ApiStatus.Result.Rule);
      } else {
        setFareRulesHtml(failedResponseForFareRules);
      }
    } else {
      setFareRulesHtml(failedResponseForFareRules);
    }
    setIsLoading(false);
    setIsOpenFareRulesDialog(true);
  };

  const handleSelectForEmail = (fare) => {
    onSelectForEmail(onwardFlight, returnFlight, fare);
  };

  const isFareSelectedForEmail = (fare) => {
    if (flightsForEmail.length > 0) {
      const present = flightsForEmail.some(
        (d) => d.fare.nextraflightkey === fare.nextraflightkey,
      );
      if (present) {
        return true;
      }
      return false;
    }
    return false;
  };

  const getMealForFlight = (fareType) => {
    if (onwardFlight.islcc === 'false') {
      return 'Free';
    }
    if (
      // fareType.toLowerCase().indexOf('corporate') > -1 ||
      fareType.toLowerCase().indexOf('flexi') > -1
    ) {
      return 'Meals included';
    }
    return 'Chargeable';
  };

  const getWaterMarkForFare = () => {
    let watermark = '';
    for (let i = 0; i < 100; i++) {
      watermark += `${getUserAgentId()} `;
    }
    return watermark;
  };

  function FareComponent({ fare }) {
    // New fare card with inclusions & penalties (toggle: FareCardWithInclusion
    // in saas/AppConfigWrapper.jsx).
    if (appConfig?.FareCardWithInclusion) {
      return (
        <FareCard
          fare={fare}
          watermark={getWaterMarkForFare()}
          isSelected={fare.nextraflightkey === userSelectedFare.nextraflightkey}
          onSelect={setUserSelectedFare}
          topActions={
            appConfig.companyName === 'Vayaonline' &&
            fare.supplierName === 'STTECH' ? (
              <span className="fs-12">{fare.flightCarrier?.[0]}</span>
            ) : null
          }
          priceClassName={
            appConfig.ShowTboPriceBlack === 'true' &&
            fare?.supplierName?.toLowerCase() === 'tbo'
              ? ''
              : 'primary-color'
          }
          showInvoiceFare={showInvoiceFare}
          fareBreakup={
            <FareBreakup fare={fare} showInvoiceFare={showInvoiceFare} />
          }
          checkinFallback={getCabinBaggage(
            fare.flightBagWeight?.[0],
            fare.flightBagUnit?.[0],
          )}
          cabinFallback={getCabinBaggage(
            fare.cabinBagweight?.[0],
            fare.cabinBagunit?.[0],
          )}
          infoRows={[
            {
              label: 'Onward Class',
              value: fare.bookingClass?.join(','),
              className: 'class',
            },
            {
              label: 'Return Class',
              value: fare.returnBookingClass?.join(','),
              className: 'class',
            },
            ...(showSupplier()
              ? [
                  {
                    label: 'Supplier',
                    value: getSupplierName(fare.supplierName),
                    className: 'suppiler',
                  },
                ]
              : []),
          ]}
          seatGroups={[
            {
              label: 'Onward',
              seats:
                fare.numseatsavailable ||
                onwardFlight?.flightlegs?.map((leg) => leg.numseatsavailable),
            },
            {
              label: 'Return',
              seats:
                fare.returnNumseatsavailable ||
                returnFlight?.flightlegs?.map((leg) => leg.numseatsavailable),
            },
          ]}
          links={
            <>
              <AppLink
                linkText="Fare Rules"
                variant="secondary"
                className="fs-14"
                onClick={() => handleFareRulesClick(fare)}
              />
              {(fare.isminifarerulesrequired === 'true' ||
                fare.isBrandedFare) && (
                <AppLink
                  linkText="Mini Fare rules"
                  variant="secondary"
                  className="fs-12"
                  onClick={() => handleShowMiniFareRules(fare)}
                />
              )}
            </>
          }
          onBook={handleBook}
          footer={
            <>
              <AppCheckBox
                name="emailorwhatsapp"
                id={fare.nextraflightkey}
                labelText="Share via Email or WhatsApp"
                onChange={() => handleSelectForEmail(fare)}
                checked={isFareSelectedForEmail(fare)}
              />
              {fare.airFreeText?.length > 0 && (
                <div className="fs-12 green-color">
                  {fare.airFreeText.join(',')}
                </div>
              )}
            </>
          }
        />
      );
    }
    return (
      <div
        className={`fare-component-mobile ${
          fare.isBrandedFare ? 'branded-border' : ''
        } fare-component-watermark`}
        // onClick={() => handleFareSelection(fare)}
        data-watermark={getWaterMarkForFare()}
      >
        <div className="d-flex justify-content-between flex-column h-100 fareCard">
          <div className="watermark-actions d-flex justify-content-between align-items-center">
            <AppRadioInput
              id={fare.nextraflightkey}
              name={fare.nextraflightkey}
              radioClassName="radioButton"
              checked={
                fare.nextraflightkey === userSelectedFare.nextraflightkey
              }
              onChange={() => setUserSelectedFare(fare)}
              labelText={
                fare.nextraflightkey === userSelectedFare.nextraflightkey
                  ? 'Selected'
                  : 'Select'
              }
            />
            {appConfig.companyName === 'Vayaonline' &&
              fare.supplierName === 'STTECH' && (
                <span className="fs-12">{fare.flightCarrier?.[0]}</span>
              )}
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Fare Type</span>
              <span className="fs-16 fw-600 text-capitalize fare-type-span d-flex">
                <span className="fareType">{fare.faretype}</span>
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Cancellation</span>
              <span className="fare-component_value">chargeable</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Reschedule</span>
              <span className="fare-component_value">chargeable</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Meal</span>
              <span className="fare-component_value">
                {getMealForFlight(fare.faretype)}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Seat</span>
              <span className="fare-component_value">chargeable</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Check In</span>
              <span className="fare-component_value checkIn">
                {getCabinBaggage(
                  fare.flightBagWeight[0],
                  fare.flightBagUnit[0],
                )}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Cabin</span>
              <span className="fare-component_value cabin">
                {getCabinBaggage(fare.cabinBagweight[0], fare.cabinBagunit[0])}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Onward Class</span>
              <span className="fare-component_value class">
                {fare.bookingClass.join(',')}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="fare-component_title">Return Class</span>
              <span className="fare-component_value class">
                {fare.returnBookingClass.join(',')}
              </span>
            </div>
            {showSupplier() && (
              <div className="d-flex justify-content-between align-items-center">
                <span className="fare-component_title">Supplier</span>
                <span className="fare-component_value suppiler">
                  {getSupplierName(fare.supplierName)}
                </span>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center mt-1">
              <span className="fare-component_value">
                {fare.refundableinfo === 'Y' ? (
                  <span className="fare_refundable reFundableInfo">
                    Refundable
                  </span>
                ) : (
                  <span className="fare_non-refundable reFundableInfo">
                    Non Refundable
                  </span>
                )}
              </span>
              {(() => {
                const onwardSeats =
                  fare?.numseatsavailable ||
                  onwardFlight?.flightlegs?.map(
                    (leg) => leg.numseatsavailable,
                  ) ||
                  [];
                const returnSeats =
                  fare?.returnNumseatsavailable ||
                  returnFlight?.flightlegs?.map(
                    (leg) => leg.numseatsavailable,
                  ) ||
                  [];
                const hasOnward =
                  onwardSeats.length > 0 && parseInt(onwardSeats[0], 10) > 0;
                const hasReturn =
                  returnSeats.length > 0 && parseInt(returnSeats[0], 10) > 0;

                if (!hasOnward && !hasReturn) return null;

                const [firstOnwardSeat] = onwardSeats;
                const [firstReturnSeat] = returnSeats;
                const primarySeat = hasOnward
                  ? firstOnwardSeat
                  : firstReturnSeat;

                return (
                  <span className="fs-12 red-color fw-600">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip
                          id={`available-seats-tooltip-${fare.nextraflightkey}`}
                        >
                          <div className="text-start">
                            {hasOnward && hasReturn ? (
                              <>
                                <div>Onward: {onwardSeats.join(', ')}</div>
                                <div>Return: {returnSeats.join(', ')}</div>
                              </>
                            ) : (
                              <div>
                                Seats left:{' '}
                                {(hasOnward ? onwardSeats : returnSeats).join(
                                  ', ',
                                )}
                              </div>
                            )}
                          </div>
                        </Tooltip>
                      }
                    >
                      <span style={{ cursor: 'pointer' }}>
                        {getNumSeats(primarySeat)} seats left
                      </span>
                    </OverlayTrigger>
                  </span>
                );
              })()}
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center my-2 watermark-actions">
              <div className="d-flex gap-2 align-items-center">
                <div className="d-flex flex-column">
                  <div
                    className={`fs-16 fw-600 totalFare ${
                      appConfig.ShowTboPriceBlack === 'true' &&
                      fare?.supplierName?.toLowerCase() === 'tbo'
                        ? ''
                        : 'primary-color'
                    }`}
                  >
                    {formatCurrency(fare.totalfq)}
                  </div>
                  {showInvoiceFare && (
                    <div className="fs-12 secondary-color">
                      {formatCurrency(fare.totalnet)}
                    </div>
                  )}
                </div>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="fare-breakup-tooltip">
                      <div className="fare-breakup">
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Base Fare</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totalbasefare)}
                          </div>
                        </div>
                        {/* <div className="fare-breakup_content">
                      <div className="fare-breakup_title">YQ Tax</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(getYQForTheFare(fare))}
                      </div>
                    </div> */}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Tax</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totaltax)}
                          </div>
                        </div>
                        {/* <div className="fare-breakup_content">
                      <div className="fare-breakup_title">K3</div>
                      <div className="fare-breakup_value">
                        {formatCurrency(getK3ForTheFare(fare))}
                      </div>
                    </div> */}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">HC</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.handlingcharges)}
                          </div>
                        </div>
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">
                            {' '}
                            {appConfig?.isIntlClient === 'true' ? 'VAT' : 'GST'}
                          </div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.servicetax)}
                          </div>
                        </div>
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">
                            Other Charges
                          </div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.transactionfee)}
                          </div>
                        </div>

                        {showInvoiceFare && (
                          <>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">Discount</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.discount)}
                              </div>
                            </div>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">TDS</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.tds)}
                              </div>
                            </div>
                            <div className="fare-breakup_content">
                              <div className="fare-breakup_title">Net Fare</div>
                              <div className="fare-breakup_value">
                                {formatCurrency(fare.totalnet)}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="fare-breakup_content">
                          <div className="fare-breakup_title">Total Fare</div>
                          <div className="fare-breakup_value">
                            {formatCurrency(fare.totalfq)}
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                  }
                >
                  <div className="cursor-pointer secondary-color">
                    <MdInfo />
                  </div>
                </OverlayTrigger>
              </div>
              <div className="d-flex flex-column">
                <AppLink
                  linkText="Fare Rules"
                  variant="secondary"
                  className="fs-14"
                  onClick={() => handleFareRulesClick(fare)}
                />
                {(fare.isminifarerulesrequired === 'true' ||
                  fare.isBrandedFare) && (
                  <AppLink
                    linkText="Mini Fare rules"
                    variant="secondary"
                    className="fs-10"
                    onClick={() => handleShowMiniFareRules(fare)}
                  />
                )}
              </div>
            </div>
            <div className="d-flex my-1 watermark-actions">
              <AppButton
                btnText="Book now"
                variant="primary"
                className="fs-16 flex-1 bookNow"
                onClick={() => handleBook(fare)}
              />
            </div>
            <div className="watermark-actions">
              <AppCheckBox
                name="emailorwhatsapp"
                id={fare.nextraflightkey}
                labelText="Share via Email or WhatsApp"
                onChange={() => handleSelectForEmail(fare)}
                checked={isFareSelectedForEmail(fare)}
              />
            </div>
            {fare.airFreeText.length > 0 && (
              <div className="mt-1 fs-12 green-color">
                {fare.airFreeText.join(',')}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  const handleCheckBox = () => {
    const present = flightsForEmail.some(
      (d) => d.nextraflightkey === onwardFlight.nextraflightkey,
    );
    setSelectedForEmail(present);
  };

  const handleShowFlightDetails = () => {
    setShowFlightDetails(true);
    setSelectedTab(FLIGHT_INFO);
  };

  useEffect(() => {
    handleCheckBox();
  }, [flightsForEmail]);

  function FlightInfo({ flight, isOnward }) {
    const getTerminal = (city, terminal) => (
      <span style={{ fontSize: '12px', color: '#768391' }}>
        {city}
        {terminal !== '' && terminal !== 'null' && terminal !== '-' && (
          <>-{terminal}</>
        )}
      </span>
    );

    return (
      <>
        <Row
          className={`spacing-0 flex-1 flight-info_flight-details ${
            isOnward ? 'pb-2' : 'mt-2'
          }`}
          style={{ borderBottom: isOnward ? '1px solid #e9e9e9' : 'none' }}
        >
          <Col
            lg={4}
            md={4}
            sm={4}
            xs={4}
            className="d-flex flex-sm-row flex-column"
          >
            <div className="flight-info_flight-details">
              <div className="d-flex">
                <div className="d-flex me-2 flight-image">
                  <AppFlightLogo
                    carrier={flight.flightlegs[0].carrier.substring(0, 2)}
                    className="vertical-bottom"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column flight-name">
              <span className="flight-company flightCompanyName ">
                {flight.flightlegs[0].validatingcarriername}
              </span>
              <span className="fs-10 flight-number flightNumber ">
                {getFlightNumbers(flight, userSelectedFare, isOnward !== true)}
              </span>
              {!isMobileWidth() && (
                <>
                  {getEquipment(flight, userSelectedFare, !isOnward) !== '' && (
                    <span className="fs-8 fw-300 grey-color flight-equipment equipmentDetials">
                      {getEquipment(flight, userSelectedFare, !isOnward)
                        ?.trim()
                        ?.toUpperCase() === 'BUS' ||
                      getEquipment(flight, userSelectedFare, !isOnward)
                        ?.trim()
                        ?.toUpperCase() === 'BUS TRANSFER'
                        ? 'Bus Transfer'
                        : `Equipment: ${getEquipment(
                            flight,
                            userSelectedFare,
                            !isOnward,
                          )}`}
                    </span>
                  )}
                  {getOperatedBy(flight, userSelectedFare, !isOnward) !==
                    '' && (
                    <span className="fs-8 fw-300 grey-color flight-operated-by OperatedBy">
                      Operated By:{' '}
                      {getOperatedBy(flight, userSelectedFare, !isOnward)}
                    </span>
                  )}
                </>
              )}
            </div>
          </Col>
          <Col lg={8} md={8} sm={8} xs={8}>
            {!isMobileWidth() ? (
              <Row>
                <Col
                  lg={5}
                  md={5}
                  sm={5}
                  xs={5}
                  className="d-flex justify-content-start"
                >
                  <div className="d-flex flex-column">
                    <span className="title fw-600 depTime">
                      {isAmPmFormat
                        ? formatTimeStringAmPmFormat(
                            flight.flightlegs[0].deptime,
                          )
                        : formatTimeString(flight.flightlegs[0].deptime)}
                    </span>
                    <span className="depTerminal">
                      {getTerminal(
                        flight.flightlegs[0].origin,
                        flight.flightlegs[0].depterminal,
                      )}
                    </span>
                  </div>
                </Col>
                <Col
                  lg={2}
                  md={2}
                  sm={2}
                  xs={2}
                  className="d-flex justify-content-center  px-0"
                >
                  <div className="d-flex flex-column text-center">
                    <span className="fs-12 fw-500 grey-color flightDuration">
                      {convertTravelTime(flight.totaljourneyduration)}
                    </span>
                    <StopOverInfo flight={flight} />
                  </div>
                </Col>
                <Col
                  lg={5}
                  md={5}
                  sm={5}
                  xs={5}
                  className="d-flex justify-content-end"
                >
                  <div className="d-flex flex-column text-end">
                    <span className="title fw-600 arrTime">
                      {isAmPmFormat
                        ? formatTimeStringAmPmFormat(
                            flight.flightlegs[flight.flightlegs.length - 1]
                              .arrtime,
                          )
                        : formatTimeString(
                            flight.flightlegs[flight.flightlegs.length - 1]
                              .arrtime,
                          )}
                      {flight.flightlegs[0].depdate !==
                        flight.flightlegs[flight.flightlegs.length - 1]
                          .arrdate && <span className="extra-days">+1</span>}
                    </span>
                    <span className="arrTerminal">
                      {getTerminal(
                        flight.flightlegs[flight.flightlegs.length - 1]
                          .destination,
                        flight.flightlegs[flight.flightlegs.length - 1]
                          .arrterminal,
                      )}
                    </span>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row className="spacing-8">
                <Col xs={6}>
                  <div className="d-flex flex-column">
                    <span className="title fw-600">
                      {formatTimeString(flight.flightlegs[0].deptime)}
                    </span>
                    <span className="fs-12 fw-300 grey-color">
                      {convertTravelTime(flight.totaljourneyduration)}
                    </span>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="d-flex flex-column text-center">
                    <span className="title fw-600">
                      {formatTimeString(
                        flight.flightlegs[flight.flightlegs.length - 1].arrtime,
                      )}
                      {flight.flightlegs[0].depdate !==
                        flight.flightlegs[flight.flightlegs.length - 1]
                          .arrdate && <span className="extra-days">+1</span>}
                    </span>
                    <span className="fs-12 fw-300 grey-color">
                      <StopOverInfo flight={flight} />
                    </span>
                  </div>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </>
    );
  }
  const handleNavigateToBookingPage = () => {
    onNavigateToBookingPage(userSelectedFare.nextraflightkey, repriceResponse);
  };

  return (
    <>
      <section
        className={` d-flex my-2 one-way-new-result-card roundIntlResultCard ${
          showFares ? 'mb-0 pb-1' : ''
        }`}
      >
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            onHide={() => setAlert(undefined)}
            description={alert.description}
          />
        )}
        {!isMobileWidth() ? (
          <>
            <div className="d-flex flight-info flex-column gap-0">
              <FlightInfo flight={onwardFlight} isOnward />
              <FlightInfo flight={returnFlight} />
              {appConfig?.appMainUrl === 'https://uatb2badmin.etrvl.com/' && (
                // onwardFlight.islcc === 'false' &&
                //   onwardFlight.supplier.toLowerCase() === 'uapi'
                <AppLink
                  linkText="Class Availability"
                  className="fs-12 fw-500 mt-1"
                  variant="green"
                  onClick={getAvailClasses}
                />
              )}
            </div>
            <div className=" d-flex fare-info justify-content-between ">
              <div className="d-flex flex-column me-3 flex-1 text-end ">
                <span className="fs-18 fw-600 secondary-color totalPrice">
                  {/* {formatCurrency(onwardFlight.flightfare[0].totalfq)} */}
                  {formatCurrency(userSelectedFare.totalfq)}
                </span>
                {showInvoiceFare && (
                  <span className="fs-12 fw-400 primary-color">
                    {/* {formatCurrency(onwardFlight.flightfare[0].totalnet)} */}
                    {formatCurrency(userSelectedFare.totalnet)}
                  </span>
                )}
                <span className="fs-10 fw-600 red-color ">
                  {/* {getNumSeats(onwardFlight.flightfare[0].numseatsavailable[0])}{' '}
                  seats left */}
                  {parseInt(
                    onwardFlight.flightfare[0].numseatsavailable[0],
                    10,
                  ) === 0
                    ? ''
                    : `${getNumSeats(
                        onwardFlight.flightfare[0].numseatsavailable[0],
                      )} seats left`}
                </span>
              </div>
              <div className="d-flex flex-column align-items-center">
                {isMoreFaresLoading ? (
                  <div className="d-flex justify-content-center mt-2">
                    <div className="dots-container d-flex align-items-center">
                      <div className="dot" />
                      <div className="dot" />
                      <div className="dot" />
                    </div>
                  </div>
                ) : (
                  <AppLink
                    linkText={showFares ? 'Hide Fares' : 'More Fares'}
                    className="fs-14 fw-600 viewPrice"
                    variant="secondary"
                    onClick={handleShowMoreFares}
                  />
                )}
                <AppLink
                  linkText={formattedMessage('flight_details')}
                  className="fs-12 fw-600 mt-1 flightDetails"
                  variant="primary"
                  onClick={handleShowFlightDetails}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="flight-info" onClick={handleMobileContinue}>
            <Row className="spacing-8">
              <Col xs={8}>
                <FlightInfo flight={onwardFlight} isOnward />
                <FlightInfo flight={returnFlight} />
              </Col>
              <Col xs={4}>
                <div className="d-flex flex-column text-end">
                  <div className="fs-18 fw-600 primary-color ">
                    {formatCurrency(onwardFlight.flightfare[0].totalfq)}
                  </div>
                  <AppLink
                    linkText={formattedMessage('flight_details')}
                    className="fs-10 fw-600 mt-1 flightDetails"
                    variant="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShowFlightDetails();
                    }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        )}
        {isMobileWidth() && showMobileFares && (
          <AppSidebar
            onHideSidebar={handleCloseMobileFare}
            sidebarTitle={
              <div className="d-flex justify-content-between p-2 align-items-center flex-1">
                <div className="fs-14 white-color fw-400 ">
                  <div>
                    {searchRequest.originLocation.split(',')[0]} to{' '}
                    {searchRequest.destinationLocation.split(',')[0]}
                  </div>
                  <div className="fs-10">
                    <span>{searchRequest.journeytype} | </span>
                    {formatDate(
                      getNewDate(searchRequest.onwarddate),
                      DATE_MONTH_YEAR_VIEW_FORMAT,
                    )}{' '}
                    {formatDate(
                      getNewDate(searchRequest.returndate),
                      DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                    )}
                  </div>
                </div>
                <div className="d-flex  align-items-center">
                  <AppIconButton
                    className="white-color p-0"
                    variant="transparent"
                    onClick={() => setShowShareOptions((prev) => !prev)}
                  >
                    {showShareOptions ? <MdClose /> : <MdOutlineShare />}
                  </AppIconButton>
                  {showShareOptions && (
                    <div className="d-flex align-items-center justify-content-center">
                      <AppIconButton
                        variant="transparent"
                        onClick={onShareViaEmail}
                      >
                        <MdOutlineEmail className="white-color fs-4" />
                      </AppIconButton>
                      <AppIconButton
                        variant="transparent"
                        onClick={onShareViaWhatsapp}
                      >
                        <MdOutlineWhatsapp className="white-color fs-4" />
                      </AppIconButton>
                    </div>
                  )}
                </div>
              </div>
            }
          >
            <>
              <div className="p-1 secondary-background-color white-color fs-14 fw-500">
                Onward Journey
              </div>
              <div className="p-0 p-lg-3">
                <SelectedFlightDetails
                  selectedFlight={onwardFlight}
                  selectedFare={userSelectedFare}
                  isOnward
                />
              </div>
              <div className="p-1 secondary-background-color white-color fs-14 fw-500">
                Return Journey
              </div>
              <div className="p-0 p-lg-3">
                <SelectedFlightDetails
                  selectedFlight={returnFlight}
                  selectedFare={userSelectedFare}
                  isOnward={false}
                />
              </div>
              <div className="fare-components-list">
                {onwardFlight.flightfare.map((fare) => {
                  return appConfig.isMoreFaresRequiredForEachFareType ? (
                    <OneWayFareComponent
                      key={fare.nextraflightkey}
                      fare={fare}
                      userSelectedFare={userSelectedFare}
                      setUserSelectedFare={setUserSelectedFare}
                      searchRequest={searchRequest}
                      showInvoiceFare={showInvoiceFare}
                      handleFareRulesClick={handleFareRulesClick}
                      flight={onwardFlight}
                      returnFlight={returnFlight}
                      handleShowMiniFareRules={handleShowMiniFareRules}
                      handleBook={handleBook}
                      handleSelectForEmail={handleSelectForEmail}
                      isFareSelectedForEmail={isFareSelectedForEmail}
                      setIsLoading={setIsLoading}
                      journeyType="roundtrip"
                      domint="international"
                      isAmPmFormat={isAmPmFormat}
                      isRtIntl
                    />
                  ) : (
                    <FareComponent key={fare.nextraflightkey} fare={fare} />
                  );
                })}
              </div>
            </>
          </AppSidebar>
        )}
        {isOpenFareRulesDialog && (
          <AppSidebar
            sidebarTitle={formattedMessage('fare_rules_btn')}
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setIsOpenFareRulesDialog(false)}
            className="overflow-auto flight-details-sidebar"
          >
            <FareRulesContent
              html={fareRulesHtml}
              style={{ overflow: 'auto' }}
              className="fs-12 fare-rules-content"
            />
          </AppSidebar>
        )}
        {isOpenMiniFareRulesDialog && (
          <AppSidebar
            sidebarTitle="Mini Fare Rules"
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setIsOpenMiniFareRulesDialog(false)}
            className="overflow-auto flight-details-sidebar"
          >
            <table className="table-bordered w-100 fs-14 mini-fare-rules-table">
              <thead>
                <tr>
                  <th>{isAmedeusFareRules ? 'TypeQualifier' : 'Type'}</th>
                  <th>Description</th>
                  <th>Charges</th>
                </tr>
              </thead>
              {isAmedeusFareRules ? (
                <tbody>
                  {miniFareRulesHtml.map((x, index) => (
                    <tr key={index}>
                      <td>{x.TypeQualifier}</td>
                      <td>{x.Description}</td>
                      <td>{`${x.Currency} ${x.Amount}`}</td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td>Reschedule Charges</td>
                    {/* <td>Adult</td> */}
                    <td>{miniFareRulesHtml?.reshedule[0]?.description}</td>
                    <td>{miniFareRulesHtml?.reshedule[0]?.amount}</td>
                  </tr>
                  <tr>
                    <td>Cancellation Charges</td>
                    {/* <td>Adult</td> */}
                    <td>{miniFareRulesHtml?.cancellation[0]?.description}</td>
                    <td>{miniFareRulesHtml?.cancellation[0]?.amount}</td>
                  </tr>
                </tbody>
              )}
            </table>
          </AppSidebar>
        )}

        {showFlightDetails && (
          <AppSidebar
            sidebarTitle={formattedMessage('flight_details')}
            animatedClass="slide-from-right-animation"
            onHideSidebar={() => setShowFlightDetails(false)}
            className="flight-details-sidebar"
          >
            <div className="flight-details_tabs">
              <div className="flight-details_tabs_container">
                <button
                  onClick={() => setSelectedTab(FLIGHT_INFO)}
                  className={`flightDetailsTab ${
                    selectedTab === FLIGHT_INFO ? 'selected-tab-btn' : 'tab-btn'
                  }`}
                >
                  {formattedMessage('flight_information')}
                </button>
                <button
                  onClick={() => setSelectedTab(FARE_BREAKUP)}
                  className={`fareSummaryTab ${
                    selectedTab === FARE_BREAKUP
                      ? 'selected-tab-btn'
                      : 'tab-btn'
                  }`}
                >
                  {formattedMessage('fare_breakup')}
                </button>
                <button
                  onClick={handleOpenFareRules}
                  className={`fareRulesTab ${
                    selectedTab === FARE_RULES ? 'selected-tab-btn' : 'tab-btn'
                  }`}
                >
                  Fare Rules
                </button>
                {(onwardFlight.isminifarerulesrequired === 'true' ||
                  returnFlight.isminifarerulesrequired === 'true') && (
                  <button
                    onClick={() => handleShowMiniFareRules(userSelectedFare)}
                    className={`fareRulesTab ${
                      selectedTab === MINIFARES ? 'selected-tab-btn' : 'tab-btn'
                    }`}
                  >
                    Mini Fare Rules
                  </button>
                )}
              </div>
            </div>

            {selectedTab === FLIGHT_INFO && (
              <>
                <div className="selected-flight-details__trip-details mt-2">
                  <div className="d-flex gap-2 trip-content align-items-center">
                    <span className="sector-span arrDeptDetails">{`Onward | ${
                      searchRequest.originLocation.split(',')[0]
                    }(${searchRequest.origin}) -> ${
                      searchRequest.destinationLocation.split(',')[0]
                    }(${searchRequest.destination})`}</span>
                    <span className="date-span">
                      {` ${formatDate(
                        getNewDate(searchRequest.onwarddate),
                        DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                      )}`}
                    </span>
                  </div>
                </div>
                <div className="p-0 p-lg-3">
                  <SelectedFlightDetails
                    selectedFlight={onwardFlight}
                    selectedFare={userSelectedFare}
                    isOnward
                  />
                </div>
                <div className="selected-flight-details__trip-details mt-2">
                  <div className="d-flex gap-2 trip-content align-items-center">
                    <span className="sector-span arrDeptDetails">{`Return | ${
                      searchRequest.destinationLocation.split(',')[0]
                    }(${searchRequest.destination}) -> ${
                      searchRequest.originLocation.split(',')[0]
                    }(${searchRequest.origin})`}</span>
                    <span className="date-span">
                      {` ${formatDate(
                        getNewDate(searchRequest.returndate),
                        DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                      )}`}
                    </span>
                  </div>
                </div>
                <div className="p-0 p-lg-3">
                  <SelectedFlightDetails
                    selectedFlight={returnFlight}
                    selectedFare={userSelectedFare}
                    isOnward={false}
                  />
                </div>
              </>
            )}
            {selectedTab === FARE_BREAKUP && (
              <div className="fare-breakup mt-3">
                <div className="fare-breakup_header">
                  <div className="fare-breakup_header_title">
                    <FormattedMessage id="fare_breakup_summary_caps" />
                  </div>
                  <div className="fare-breakup_header_value">
                    <FormattedMessage id="amount_caps" />
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Base Fare</div>
                  <div className="fare-breakup_value baseFare fareSummaryBreakUp">
                    {formatCurrency(userSelectedFare.totalbasefare)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">OT Tax</div>
                  <div className="fare-breakup_value otTax fareSummaryBreakUp">
                    {formatCurrency(userSelectedFare.totaltax)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Handling charges</div>
                  <div className="fare-breakup_value handlingCharges fareSummaryBreakUp">
                    {formatCurrency(userSelectedFare.handlingcharges)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">
                    {' '}
                    {appConfig?.isIntlClient === 'true' ? 'VAT' : 'GST'}
                  </div>
                  <div className="fare-breakup_value gst fareSummaryBreakUp">
                    {formatCurrency(userSelectedFare.servicetax)}
                  </div>
                </div>
                <div className="fare-breakup_content">
                  <div className="fare-breakup_title">Other Charges</div>
                  <div className="fare-breakup_value otherCharges fareSummaryBreakUp">
                    {formatCurrency(userSelectedFare.transactionfee)}
                  </div>
                </div>
                {showInvoiceFare && (
                  <>
                    <div className="fare-breakup_content">
                      <div className="fare-breakup_title">Discount</div>
                      <div className="fare-breakup_value fareSummaryBreakUp">
                        {formatCurrency(userSelectedFare.discount)}
                      </div>
                    </div>
                    <div className="fare-breakup_content">
                      <div className="fare-breakup_title">TDS</div>
                      <div className="fare-breakup_value fareSummaryBreakUp">
                        {formatCurrency(userSelectedFare.tds)}
                      </div>
                    </div>
                    <div className="fare-breakup_footer">
                      <div className="fare-breakup_title">Net Fare</div>
                      <div className="fare-breakup_value fareSummaryBreakUp">
                        {formatCurrency(userSelectedFare.totalnet)}
                      </div>
                    </div>
                  </>
                )}
                <div className="fare-breakup_footer">
                  <div className="fare-breakup_title">Total Fare</div>
                  <div className="fare-breakup_value userTotalFare">
                    {formatCurrency(userSelectedFare.totalfq)}
                  </div>
                </div>
              </div>
            )}
            {selectedTab === FARE_RULES && (
              <div className="pt-3 mt-3">
                <FareRulesContent
                  html={fareRulesHtml}
                  style={{ overflow: 'auto' }}
                  className="fs-12 fare-rules-content"
                />
              </div>
            )}
          </AppSidebar>
        )}
      </section>
      {showFares && (
        <div className="fare-components-list fareComponentsList">
          {onwardFlight.flightfare.map((fare) => {
            return appConfig.isMoreFaresRequiredForEachFareType ? (
              <OneWayFareComponent
                key={fare.nextraflightkey}
                fare={fare}
                userSelectedFare={userSelectedFare}
                setUserSelectedFare={setUserSelectedFare}
                searchRequest={searchRequest}
                showInvoiceFare={showInvoiceFare}
                handleFareRulesClick={handleFareRulesClick}
                flight={onwardFlight}
                returnFlight={returnFlight}
                handleShowMiniFareRules={handleShowMiniFareRules}
                handleBook={handleBook}
                handleSelectForEmail={handleSelectForEmail}
                isFareSelectedForEmail={isFareSelectedForEmail}
                setIsLoading={setIsLoading}
                journeyType="roundtrip"
                domint="international"
                isAmPmFormat={isAmPmFormat}
                isRtIntl
              />
            ) : (
              <FareComponent key={fare.nextraflightkey} fare={fare} />
            );
          })}
        </div>
      )}
      {/* {index === 2 && (
        <div className="add-space-container my-2">
          <img
            src={
              getValueFromAppConfig('adspaceimage') || '/images/addspace.png'
            }
            alt=""
          />
        </div>
      )} */}
      {showClassAvailModal && availClassList.length > 0 && (
        <AppSidebar
          sidebarTitle="Class Availability"
          className="flight-details-sidebar"
          animatedClass="slide-from-right-animation"
          onHideSidebar={handleCloseClassAvailabilityModal}
        >
          <div className="p-2 d-flex flex-column">
            <div className="d-flex align-items-center justify-content-between fs-14 ">
              <div className="fw-500">Select Classes</div>
              <div className="d-flex justify-content-end">
                <AppButton
                  onClick={handleCloseClassAvailabilityModal}
                  btnText="Close"
                  variant="outlined"
                />
              </div>
            </div>
            {availClassList.map((resultRow, index) => (
              <div
                key={`${resultRow.carrier}-${resultRow.flightnumber}`}
                className="fs-12 my-2"
              >
                <div>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th colSpan={resultRow.availclasses.length}>
                          {resultRow.carrier}-{resultRow.flightnumber}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {resultRow.availclasses.map((availClass) => (
                          <td
                            key={availClass.class}
                            onClick={() =>
                              handleClassSelect(
                                availClass,
                                'selectedclass',
                                index,
                              )
                            }
                            className={`p-0 ${
                              selectedClasses[index].selectedclass ===
                              availClass.class
                                ? 'selected-class-availability-row-value'
                                : 'class-availability-row-value'
                            }`}
                          >
                            <div className="d-flex flex-column align-items-center">
                              <span className="p-1 border-bottom">
                                {availClass.class}
                              </span>
                              <span className="p-1">{availClass.count}</span>
                            </div>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
            <div className="d-flex justify-content-end">
              {!isFareFetched && (
                <AppButton btnText="Fetch Fare" onClick={handleFetchFare} />
              )}

              {userSelectedFare && repriceResponse && (
                <div className="d-flex gap-2 align-items-center">
                  <span className="fs-14 fw-600">
                    {formatCurrency(
                      repriceResponse.flightjourneys[0].flightoptions[0]
                        .recommendedflight[0].flightfare.totalfq,
                    )}
                  </span>

                  <AppButton
                    btnText="Book"
                    onClick={handleNavigateToBookingPage}
                  />
                </div>
              )}
            </div>
          </div>
        </AppSidebar>
      )}
    </>
  );
}

RoundTripIntlResultCard.defaultProps = {
  selectedFare: undefined,
};

RoundTripIntlResultCard.propTypes = {
  onwardFlight: PropTypes.object.isRequired,
  selectedFare: PropTypes.object,
  returnFlight: PropTypes.object.isRequired,
  onSelectForEmail: PropTypes.func.isRequired,
  onShareViaEmail: PropTypes.func.isRequired,
  onShareViaWhatsapp: PropTypes.func.isRequired,
  showInvoiceFare: PropTypes.bool.isRequired,
  onwardFares: PropTypes.array.isRequired,
  flightsForEmail: PropTypes.array.isRequired,
  searchRequest: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isAmPmFormat: PropTypes.bool.isRequired,
  conversionRate: PropTypes.number.isRequired,
  currencyOption: PropTypes.any.isRequired,
  onNavigateToBookingPage: PropTypes.func.isRequired,
};

export default RoundTripIntlResultCard;
